import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import {
  TableContainer, Tbody, Td, Th, Thead, Tr, Headline
} from './styles'

const Row = ({
  row, dataWidth, striped, applyBorderRadius
}) => {
  return (
    <Tr $striped={striped}>
      {_.map(row, (item, itemIdx) => (
        <Td
          key={itemIdx}
          $striped={striped}
          style={{ width: dataWidth[itemIdx] }}
          $applyBorderRadius={applyBorderRadius}
        >
          {item}
        </Td>
      ))}
    </Tr>
  )
}

const Table = ({
  data, dataHeads, dataWidth, headline, striped, applyBorderRadius
}) => {
  return (
    <TableContainer>
      <Thead>
        {headline && <Headline />}
        <Tr $striped={striped}>
          {_.map(dataHeads, (head, headIdx) => (
            <Th
              $striped={striped}
              key={headIdx}
              style={{ width: dataWidth[headIdx] }}
            >
              {head}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody $striped={striped}>
        {_.map(data, (row, rowIdx) => (
          <Row
            row={row}
            key={rowIdx}
            dataWidth={dataWidth}
            striped={striped}
            applyBorderRadius={applyBorderRadius}
          />
        ))}
      </Tbody>
    </TableContainer>
  )
}

Row.propTypes = {
  row: PropTypes.arrayOf(PropTypes.node).isRequired,
  dataWidth: PropTypes.arrayOf(PropTypes.string).isRequired,
  striped: PropTypes.bool,
  applyBorderRadius: PropTypes.bool,
}

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.array),
  dataHeads: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  dataWidth: PropTypes.arrayOf(PropTypes.string).isRequired,
  headline: PropTypes.bool,
  striped: PropTypes.bool,
  applyBorderRadius: PropTypes.bool,
}

Table.defaultProps = {
  data: [],
  headline: null,
  striped: false,
  applyBorderRadius: false,
}

Row.defaultProps = {
  striped: false,
  applyBorderRadius: false,
}

export default Table
